<template>
  <div class="web-topping" @click="scrollToTop" v-show="toTopShow">

  </div>
</template>

<script>
  export default {
    name: 'Topping',
    data() {
      return {
        toTopShow: false //滚动条是否显示
      }
    },
    mounted() {
      this.$nextTick(function() {
        window.addEventListener('scroll', this.handleScroll, true); // 取消事件冒泡，防止绑定失败
      });
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll, true); // 取消事件冒泡
    },
    methods: {
      // 显示隐藏滚动条
      handleScroll() {
        /* 获取滚动条距离顶部的位置 */
        this.scrollTop = $(document).scrollTop();
        if (this.scrollTop > 800) {
          this.toTopShow = true;
        } else {
          this.toTopShow = false;
        }
      },
      // 回到顶部
      scrollToTop() {
        var timer = setInterval(function() {
          window.scrollBy(0, -50);
          if ($(document).scrollTop() == 0) {
            clearInterval(timer);
          }
        }, 2)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .web-topping {
    width: 52px;
    height: 52px;
    background-color: #0861D1;
    border-radius: 50%;
    position: fixed;
    bottom: 40px;
    right: 180px;
    z-index: 9999;
    cursor: pointer;
    background-image: url(../assets/images/common/topping.png);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 60%;
  }

  @media screen and (max-width: 800px) {
    .web-topping {
      width: 12vw;
      height: 12vw;
      right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Topping.vue